import { render, staticRenderFns } from "./OrderItemParentOrderItem.vue?vue&type=template&id=5a7126a0"
import script from "./OrderItemParentOrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItemParentOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports